import LHSNavigation from 'AccountsDesktopComponents/LHSNavigation'
import React, { useState, useEffect } from 'react'
import PageLoader from 'Lib/Pageloader'
import { isInDomain } from 'AccountsUtils'
import { Toast } from '@cleartrip/bento'
import { checkMobileDevice } from 'AccountsUtils'
import { isInFlyinDomain } from 'AccountsUtils'
import { getAbTestConfigDesktop } from './Trips/trips.helper'

const OldShell = ({ location, children, section }) => {
  const [pageLoading, setPageLoading] = useState(true)
  const [username, setUsername] = useState('')
  const [abDesktopData, setAbDesktopData] = useState({
    hi_five: 'a'
  })
  const [showLoginSuccess, setShowLoginSuccess] = useState(false)
  const walletHeading = isInDomain() ? 'Cleartrip Wallet' : 'Your Wallet'

  const messageMap = {
    hifive: {
      message: 'Your Cleartrip profile',
      mapClass: 'descHeader'
    },
    trips: {
      message: "Trips you've booked",
      mapClass: 'descHeader'
    },
    cancel: {
      message: 'Cancellation',
      mapClass: 'descHeader'
    },
    expressway: {
      message: 'Expressway',
      mapClass: 'descHeader'
    },
    wallet: {
      message: walletHeading,
      mapClass: 'descHeader'
    }
  }

  const getCookie = cname => {
    const name = `${cname}=`
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }

  const getUserDetails = () => {
    const userId = unescape(getCookie('userid'))
    try {
      if (userId) {
        let extractedUsername = userId.split('|')[0]
        if (extractedUsername.includes('%40')) {
          extractedUsername = decodeURIComponent(
            extractedUsername.split('%257C')[0].replace('%40', '@')
          )
        }
        if (extractedUsername === 'null' || extractedUsername === '') {
          extractedUsername = 'My Wallet'
        }
        setUsername(extractedUsername)
      } else {
        setUsername('Guest User')
      }
    } catch (e) {
      setUsername('Guest User')
    }
  }

  const fetchDesktopAbData = async () => {
    try {
      const res = await getAbTestConfigDesktop()
      const { status, data } = res
      if (status === 200) {
        setAbDesktopData({
          ...abDesktopData,
          ...data
        })
      }
    } catch (e) {
      console.error(e)
    }
    setPageLoading(false)
  }

  useEffect(() => {
    fetchDesktopAbData()
    getUserDetails()
  }, [])

  useEffect(() => {
    if (window.localStorage.getItem('LoginToastShown') === 'true') {
      setShowLoginSuccess(true)
      setTimeout(() => {
        setShowLoginSuccess(false)
      }, 5000)
      window.localStorage.setItem('LoginToastShown', 'false')
    }
  }, [])

  const { pathname } = location
  const getPage = () => {
    if (pathname.endsWith('cancel')) {
      return 'cancel'
    }
    if (pathname.endsWith('expressway')) {
      return 'expressway'
    }
    if (pathname.endsWith('wallet')) {
      return 'wallet'
    }
    if (pathname.endsWith('hi-five')) {
      return 'hifive'
    }
    return 'trips'
  }

  const page = getPage()
  const { message, mapClass } = messageMap[page]

  return (
    <React.Fragment>
      <If condition={pageLoading}>
        <PageLoader />
      </If>
      <If condition={!pageLoading}>
        <section
          className="w-100p"
          style={{ backgroundColor: isInFlyinDomain() ? '#f3f5fd' : '#fff' }}
        >
          {!isInFlyinDomain() && (
            <section className="flex container">
              <div className="w-100p">
                <h1 className={mapClass}>{message}</h1>
              </div>
            </section>
          )}

          <section
            className="flex container"
            style={{ paddingTop: '20px', maxHeight: '800px' }}
          >
            {!checkMobileDevice() && (
              <aside
                className={isInFlyinDomain() ? 'w-25p' : 'w-30p'}
                style={{
                  marginRight: '20px',
                  marginLeft: '20px',
                  backgroundColor: '#fff'
                }}
              >
                {isInFlyinDomain() ? (
                  <div className="myaccpfrofile">
                    <div className="profileDetails">
                      <span>
                        <div className="profilePicImg2" />
                      </span>
                    </div>
                    <div
                      className="c-white fs-20 pt-2 fw-600"
                      style={{ textAlign: 'center' }}
                    >
                      My Flyin
                    </div>
                    <div className="c-white fs-14 pt-2 user-desc">
                      <span>
                        <p>{username}</p>
                      </span>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                <LHSNavigation
                  section={section}
                  abDesktopData={abDesktopData}
                />
              </aside>
            )}
            {children}
          </section>
        </section>
      </If>
      {showLoginSuccess && (
        <Toast
          message="Logged in successfully!"
          className="row mt-15  w-585 walletErrorToast l-0 r-0 m-auto"
          closeBtn={false}
        />
      )}
    </React.Fragment>
  )
}

export default OldShell
